<div class="agent-page p-4" *ngIf="employer">
	<div class="flex items-center mb-4 border-b pb-3">
		<nz-avatar nzSize="large" nzIcon="user"></nz-avatar>
		<div class="ml-3">
			<h2 class="text-xl font-bold mb-1">{{ employer.name }}</h2>
			<p class="text-gray-500">
				Employer ID: {{ employer.id }}
			</p>
			<p class="text-gray-400 text-sm">
				Created: {{ employer.createdAt | date }}
			</p>
		</div>
		<div class="ml-auto">
			<a nz-button nzType="default" class="mr-2" [routerLink]="['/employer',employer.id,'edit']">Edit</a>
		</div>
	</div>

	<nz-tabset nzType="card">
		<nz-tab nzTitle="Details" *ngIf="hasDynamicProperties">
			<app-employer-view-details [employer]="employer"/>
		</nz-tab>
		<nz-tab nzTitle="Members">
			<app-member-list [employerId]="employer.id"></app-member-list>
		</nz-tab>
	</nz-tabset>
</div>
